import React from 'react'
import classnames from 'classnames/bind'
import type { ShallowTaskWorkflowMilestone } from '@adc/sdk/types'
import { ColorNames } from '../../constants'
import { formatEnum } from '../../utils/formatters'
import Text from '../elementals/text'
import InfoPill from '../elementals/infoPill'
import styles from './styles.scss'
import { AutomationTarget } from '../../types'

const cx = classnames.bind(styles)

const getMilestoneStatus = (workflowStatus: string, code: string) => {
  const formattedStatus = formatEnum(workflowStatus)

  const mappings: Record<string, React.ReactNode> = {
    CLOSING_SCHEDULED: (
      <InfoPill
        content={formattedStatus}
        backgroundColor={ColorNames.CautionLight}
        foregroundColor={ColorNames.Caution}
        includeBorder
        className={cx('milestone-closing-status')}
      />
    ),
  }

  return mappings[code] || null
}

interface MilestoneLabelProps extends AutomationTarget {
  milestone: ShallowTaskWorkflowMilestone
  workflowStatus: string
  compact?: boolean
}

const MilestoneLabel: React.FC<MilestoneLabelProps> = ({
  milestone,
  workflowStatus,
  elmId = 'milestone_label',
  compact,
}) => {
  return (
    <div className={cx('milestone-label')}>
      <Text
        elmId={elmId}
        size={compact ? 'tiny' : 'small'}
        weight='heavy'
        className={cx('milestone-title')}
      >
        {milestone?.label}
      </Text>
      {getMilestoneStatus(workflowStatus, milestone?.code)}
    </div>
  )
}

export default MilestoneLabel
